const getParentNodeWithClass = (_e, className) => {
  const elem = _e && _e.target ? document.getElementById(_e.target.id) : _e;

  let r = elem.parentNode && elem.parentNode.classList ? (
    elem.parentNode.classList.contains(className) ?
      elem.parentNode :
      (
        (r = getParentNodeWithClass(elem.parentNode, className)) != null ?
          r : null
      )
  ) : null;

  return r;
};

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export {getParentNodeWithClass, inIframe};
